var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCloud(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.2084 16.7224C29.2639 11.9307 25.0556 8.3335 20 8.3335C15.9862 8.3335 12.5 10.6113 10.7639 13.9446C6.58337 14.3891 3.33337 17.9307 3.33337 22.2224C3.33337 26.8196 7.06949 30.5557 11.6667 30.5557H29.7223C33.5556 30.5557 36.6667 27.4446 36.6667 23.6113C36.6667 19.9446 33.8195 16.9724 30.2084 16.7224Z",
    fill: "black",
    fillOpacity: 0.54
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloud);
export default __webpack_public_path__ + "static/media/cloud.5be50999041a9271e0d3361780029f18.svg";
export { ForwardRef as ReactComponent };